import cx from 'classnames';
import { Component, h } from 'preact';

import { PreactHTMLConverter } from 'preact-html-converter';

// internal
import {
  sort_candidates_by_party,
} from '../election-utils';

interface Props {
  partyName: string;
  tableHeader: JSX.Element;
  notes: { [key: string]: any };
  columnCount: number;
  partyBallot: { [key: string]: any };
  renderCandidate: any;
  contestTitle: string;
}

class SeatPartyDivider extends Component {
  constructor() {
    super();

    this.state = {
      viewAllCandidates: false,
    };
  }


  render() {
    const {
      partyName,
      annotations,
      notes,
      partyBallot,
      tableHeader,
      columnCount,
      renderCandidate,
      contestTitle,
    } = this.props;

    const { viewAllCandidates } = this.state;

    const converter = PreactHTMLConverter();


    let candidates = partyBallot.candidacies;

    if (partyBallot <= 0) {
      candidates = sort_candidates_by_party(candidates);
    }

    const rowClass = cx('seat__race', {
      'seat__race--Democrat': partyName == 'Democrat',
      'seat__race--Republican': partyName == 'Republican',
    });

    const IsNoted = notes && notes.length > 0 ? true : false;

    return (
      <div class={rowClass}>
        <div class="race">
            <span>
              <h4 class="race__title">{partyName} </h4>
            </span>
          </div>

          <table class="race__candidates">
            {/* {tableHeader} */}
            <tbody>
            {candidates.map((candidate: any, idx: any) =>
                renderCandidate(candidate, idx)
              )}
            </tbody>
          </table>

          {IsNoted == true && (
            <p class="note__text">{converter.convert(notes[0].value)}</p>
          )}
        </div>
    );
  }
}

SeatPartyDivider.defaultProps = {
  isShowcaseRace: false,
  isHomepage: false,
};

export default SeatPartyDivider;